import type { StickyCardsProps } from "@op/puck-types";
import { domAnimation, LazyMotion, useScroll } from "framer-motion";
import { useRef, useState } from "react";
import { default as StickyCard } from "../../../../../components/base/StickyCard/StickyCard";

const StickyCards = ({ items }: StickyCardsProps) => {
  const container = useRef<HTMLDivElement>(null);
  const [minHeight, setMinHeight] = useState<number>(586);

  const { scrollYProgress } = useScroll({
    target: container,
  });

  function onUpdateHeight(height: number) {
    if (height > minHeight) {
      setMinHeight(height);
    }
  }

  return (
    <LazyMotion strict features={domAnimation}>
      <div ref={container} className="flex flex-col relative gap-12 w-full">
        {items.map((item, idx) => {
          const shrinkStartOffset = (1 / items.length) * (idx + 1);
          const shrinkEndOffset = (1 / items.length) * (idx + 2);
          const shrinkTarget = 1 - (items.length - idx) * 0.025;

          return (
            <StickyCard
              {...item}
              key={`${idx}`}
              shrinkStartOffset={shrinkStartOffset}
              shrinkEndOffset={shrinkEndOffset}
              shrinkTarget={shrinkTarget}
              onUpdateHeight={onUpdateHeight}
              progress={scrollYProgress}
              minHeight={minHeight}
              idx={idx}
            />
          );
        })}
      </div>
    </LazyMotion>
  );
};

export default StickyCards;
